import { render, staticRenderFns } from "./DeletePrealert.vue?vue&type=template&id=7db43d88"
import script from "./DeletePrealert.vue?vue&type=script&lang=js"
export * from "./DeletePrealert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports